import { Component, EventEmitter, Output, Input, OnInit } from "@angular/core";
import { WizardSubstep } from "../../../common/wizard/wizard-subtep.interface";
import moment from "moment";
import { AutopilotRule } from "../../../../domain/rule";

@Component({
  selector: "icn-autopilot-rule-wizard-step3-substep1",
  templateUrl: "./substep1.html",
  styleUrls: ["./substep1.scss"],
})
export class AutopilotRuleWizardStep3Substep1Component
  implements WizardSubstep, OnInit
{
  limitRuleOptions = [
    { name: "Run Rule Forever", value: false },
    { name: "Set Date and Time", value: true },
  ];

  @Input()
  rule: AutopilotRule;

  constructor() {}

  ngOnInit(): void {}

  onStartDateChange(val) {
    console.log("onStartDateChange before", this.rule.limitRuleStartDate, val);
    this.rule.limitRuleStartDate = moment(val.startOf("day")).clone();
    console.log("onStartDateChange after", this.rule.limitRuleStartDate, val);

    //this.startDateChange.emit(this.limitRuleStartDate);
  }

  onEndDateChange(val) {
    console.log("onEndDateChange ", this.rule.limitRuleEndDate, val);
    this.rule.limitRuleEndDate = moment(val.startOf("day")).clone();
    //this.endDateChange.emit(this.rule.limitRuleEndDate);
  }

  canGoNext(): boolean {
    return (
      this.rule.limitRule === false ||
      (!!this.rule.limitRuleStartDate &&
        !!this.rule.limitRuleEndDate &&
        !!this.rule.limitRuleStartTime &&
        !!this.rule.limitRuleEndTime)
    );
  }

  hourStart() {
    if (!!this.rule.limitRuleStartTime) {
      return moment(this.rule.limitRuleStartTime).hours();
    }
    return null;
  }

  hourEnd() {
    if (!!this.rule.limitRuleEndTime) {
      return moment(this.rule.limitRuleEndTime).hours();
    }
    return null;
  }

  timeStart(): number {
    if (!!this.rule.limitRuleStartTime) {
      const startTime = moment(this.rule.limitRuleStartTime);
      return startTime.hours() * 60 + startTime.minutes();
    }
    return 0;
  }

  timeEnd(): number {
    if (!!this.rule.limitRuleEndTime) {
      const endTime = moment(this.rule.limitRuleEndTime);
      return endTime.hours() * 60 + endTime.minutes();
    }
    return 0;
  }

  onStartHourChange(hour) {
    this.rule.limitRuleStartTime = moment(
      this.rule.limitRuleStartDate.valueOf(),
    )
      .startOf("day")
      .hour(hour);
    //console.log('onStartHourChange ',this.startHour,moment,moment(this.startDate.startOf('day').valueOf()),moment.utc(this.startDate.startOf('day').valueOf()));

    //return this.startHourChange.emit(this.rule.limitRuleStartTime);
  }

  onEndHourChange(hour) {
    this.rule.limitRuleEndTime = moment(this.rule.limitRuleEndDate.valueOf())
      .startOf("day")
      .hour(hour);
    //console.log('onEndHourChange ',this.endHour);
    //return this.endHourChange.emit(this.endHour);
  }

  onStartTimeChange(minutes) {
    this.rule.limitRuleStartTime = moment(
      this.rule.limitRuleStartDate.valueOf(),
    )
      .startOf("day")
      .add("minutes", minutes);
    console.log("onStartTimeChange->", this.rule.limitRuleStartTime);
    //return this.startHourChange.emit(this.startHour);
  }

  onEndTimeChange(minutes) {
    this.rule.limitRuleEndTime = moment(this.rule.limitRuleEndDate.valueOf())
      .startOf("day")
      .add("minutes", minutes);

    //return this.endHourChange.emit(this.endHour);
  }

  showTimeRangePickers() {
    return (
      !!this.rule.limitRule &&
      !!this.rule.limitRuleStartDate &&
      !!this.rule.limitRuleEndDate
    );
  }
}
